@if (strutChanges.length) {
<div data-testid="SUBSYS2_DASHBOARD_CALENDAREVENT_STRUTCHANGE_BOX" class="calendar-event strut-change"
	[ngbTooltip]="strutChangesTmp" tooltipClass="calendar-event-tooltip strut-change-tooltip" placement="right">
</div>
}
@if (strutAdjusts.length) {
<div data-testid="SUBSYS2_DASHBOARD_CALENDAREVENT_STRUTADJUST_BOX" class="calendar-event strut-adjust"
	[ngbTooltip]="strutAdjustsTmp" tooltipClass="calendar-event-tooltip strut-adjust-tooltip" placement="right">
</div>
}



<ng-template #strutChangesTmp>
	<div>{{strutEventEnum.CHANGE}}</div>
	@for (change of strutChanges; track change) {
	<div>{{eventItemDesc(change)}}</div>
	}
</ng-template>

<ng-template #strutAdjustsTmp>
	<div>{{strutEventEnum.ADJUST}}</div>
	@for (adjust of strutAdjusts; track adjust) {
	<div>{{eventItemDesc(adjust)}}</div>
	}
</ng-template>